import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const ReviewTwo = ({ reqPage }) => {
  const { t } = useLanguage();

  return (
    <>
      <div className='col-xl-5 col-lg-5 col-md-12 order-1 order-lg-0 bg-white p-4 rounded'>
        <div className='testimonial-tab-slider-wrap mt-5'>
          {reqPage ? (
            <h1 className='fw-bold text-dark display-5'>
              {t('reviewTab.title')}
            </h1>
          ) : (
            <h2 className='text-dark'>{t('reviewTab.title')}</h2>
          )}
          <p className='text-dark'>
            {t('reviewTab.description')}
          </p>
          {/* <hr /> */}
          <div
            className='tab-content testimonial-tab-content text-dark'
            id='pills-tabContent'
          >
            {/* <div
              className='tab-pane fade show active'
              id='testimonial-tab-1'
              role='tabpanel'
            >
              <blockquote className='blockquote'>
                <em>
                  {t('reviewTab.testimonials.0.quote')}
                </em>
              </blockquote>
              <div className='author-info mt-3'>
                <span className='h6'>{t('reviewTab.testimonials.0.author')}</span>
                <span className='d-block small'>{t('reviewTab.testimonials.0.role')}</span>
              </div>
            </div> */}
            {/* <div
              className='tab-pane fade'
              id='testimonial-tab-2'
              role='tabpanel'
            >
              <blockquote className='blockquote'>
                <em>
                  {t('reviewTab.testimonials.1.quote')}
                </em>
              </blockquote>
              <div className='author-info mt-3'>
                <span className='h6'>{t('reviewTab.testimonials.1.author')}</span>
                <span className='d-block small'>{t('reviewTab.testimonials.1.role')}</span>
              </div>
            </div> */}
            {/* <div
              className='tab-pane fade'
              id='testimonial-tab-3'
              role='tabpanel'
            >
              <blockquote className='blockquote'>
                <em>
                  {t('reviewTab.testimonials.2.quote')}
                </em>
              </blockquote>
              <div className='author-info mt-3'>
                <span className='h6'>{t('reviewTab.testimonials.2.author')}</span>
                <span className='d-block small'>{t('reviewTab.testimonials.2.role')}</span>
              </div>
            </div> */}
          </div>
          {/* <ul
            className='nav nav-pills mb-0 testimonial-tab-indicator mt-5'
            id='pills-tab'
            role='tablist'
          >
            <li className='nav-item' role='presentation'>
              <button
                className='nav-link active'
                data-bs-toggle='pill'
                data-bs-target='#testimonial-tab-1'
                type='button'
                role='tab'
                aria-selected='true'
              >
                <img
                  src='assets/img/testimonial/1.jpg'
                  alt='testimonial'
                  width='55'
                  className='img-fluid rounded-circle'
                />
              </button>
            </li>
            <li className='nav-item' role='presentation'>
              <button
                className='nav-link'
                data-bs-toggle='pill'
                data-bs-target='#testimonial-tab-2'
                type='button'
                role='tab'
                aria-selected='false'
              >
                <img
                  src='assets/img/testimonial/4.jpg'
                  alt='testimonial'
                  width='55'
                  className='img-fluid rounded-circle'
                />
              </button>
            </li>
            <li className='nav-item' role='presentation'>
              <button
                className='nav-link'
                data-bs-toggle='pill'
                data-bs-target='#testimonial-tab-3'
                type='button'
                role='tab'
                aria-selected='false'
              >
                <img
                  src='assets/img/testimonial/6.jpg'
                  alt='testimonial'
                  width='55'
                  className='img-fluid rounded-circle'
                />
              </button>
            </li>
          </ul> */}
        </div>
      </div>
    </>
  );
};

export default ReviewTwo;
